import { connect } from 'react-redux';
import { getCurrentUser } from 'js/reducers/session';
import { fetchRecordLineage, setContextualSupport, unsetContextualSupport } from 'js/actions';
import { GET_RECORD_LINEAGE_REQUEST } from 'js/constants/actionTypes';
import has from 'lodash/has';
import RecordLineageView from './RecordLineageView';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_MONITOR } from 'new/constants/pathnames';
import { ScreenComponent } from 'new/routes/RouterManager';

const mapStateToProps = (state) => {
  const {
    request,
    metrics: { recordLineage },
    entities: { sources, dataSets, sinks, vendors },
    paging: { metaInfoById },
  } = state;
  const currentUser = getCurrentUser(state);
  return {
    currentUser,
    isLoading:
      has(request, GET_RECORD_LINEAGE_REQUEST) && request[GET_RECORD_LINEAGE_REQUEST]
        ? true
        : false,
    recordLineage,
    sources,
    dataSets,
    sinks,
    vendors,
    metaInfoById,
  };
};

const RecordLineageContainer: ScreenComponent<any> = connect(mapStateToProps, {
  fetchRecordLineage,
  setContextualSupport,
  unsetContextualSupport,
})(RecordLineageView as any) as unknown as ScreenComponent<any>;

RecordLineageContainer.screenConfig = {
  screenName: 'RecordLineageContainer',
  header: {
    title: 'Trace Record Lineage',
    slugTitle: 'Trace Record Lineage',
  },
  domain: 'monitor',
  path: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/record-lineage`,
};

export default RecordLineageContainer;
